export default __webpack_public_path__ + "static/media/vika.be6dc96e.jpg";